module.exports = __webpack_public_path__ + "static/media/commute-img-006.c4789223.jpg";